import React from 'react';
import * as Render from '../../platformui/Base/Render';
import Image from '../../platformui/Image';
import withLazyLoad from '../../platformui/Containers/withLazyLoad';
import withSrcSets from '../../platformui/Containers/withSrcSets';
import classNames from 'classnames';

const Entry = (props) => {
  const LazyLoadImage = withSrcSets(withLazyLoad(Image));

  const textContent = classNames({
    'c-entry__text-content': true,
    'c-entry__text-content--full-width': !props.Media,
  });

  return (
    <a href={props.Href} target={props.Target} className="c-entry">
      <div className="c-entry__content-container">
        {props.Media && (
          <div className="c-entry__img-container">
            <Render.Block
              blocks={props.Media}
              propertyName="ImageReference"
              currentPageProps={props.CurrentPageProps}
            >
              <LazyLoadImage
                className="c-entry__img"
                isBackgroundImage={true}
                Sizes={{
                  sizes: '(min-width: 1025px) 1000px, (min-width: 320px) 800px',
                }}
              />
            </Render.Block>
          </div>
        )}

        <div className={textContent}>
          <div className="c-entry__text-content__inner">
            <h3 className="c-entry__text-content__heading">
              <i className="c-entry__text-content__heading__icon"></i>
              {props.Heading}
            </h3>
            <p className="c-entry__text-content__paragraph">
              {props.Description}
            </p>
          </div>
        </div>
      </div>
    </a>
  );
};

export default Entry;